<template>
  <div
    v-if="loading"
    class="text-center mt-5"
  >
    <b-spinner
      variant="primary"
    />
  </div>
  <div
    v-else
    class="row mb-5"
  >
    <div class="col-lg-3">
      <div class="list-group">
        <button
          v-for="region in regions"
          :key="region.id"
          type="button"
          class="list-group-item list-group-item-action"
          :class="{ active: selectedRegion === region.id }"
          @click="handleRegionSelect(region.id)"
        >
          {{ $langName(region.name) }}
        </button>
      </div>
    </div>

    <div class="col-lg-9">
      <div v-if="selectedRegion">
        <TopicTable ref="topicTableRef" />
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import TopicTable from '@/views/pages/front/scientific-topics/TopicTable.vue'

export default {
  name: 'ScientificTopics',
  components: { BSpinner, TopicTable },
  data() {
    return {
      selectedRegion: null,
      loading: false,
    }
  },
  computed: {
    regions() {
      return this.$store.state.staticModule.regions || []
    },
  },
  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('staticModule/regions')
      if (this.regions.length > 0) {
        this.handleRegionSelect(this.regions[0].id) // default region
      }
    } finally {
      this.loading = false
    }
  },
  methods: {
    handleRegionSelect(regionId) {
      this.selectedRegion = regionId

      this.$router.replace({ query: { ...this.$route.query, region: regionId } })

      this.$nextTick(() => {
        // eslint-disable-next-line no-unused-expressions
        this.$refs.topicTableRef?.refetchData()
      })
    },
  },
}
</script>
